import { UpsertDeviceModal } from '../UpsertDeviceModal'
import translations from './DeviceCreateButton.i18n.json'
import { createCreateButton } from 'modules/Admin/components/CreateButton'

export const DeviceCreateButton = createCreateButton({
  translations: translations,
  UpsertModal: UpsertDeviceModal,
})
